import ApiClient from './ApiClient';

class TicketTypesApi extends ApiClient {
  constructor() {
    super('ticket_types', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TicketTypesApi();
